import React from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import WebsiteImage from 'components/WebsiteImage';
import { BlockQuoteContainer } from './styles';
import SocialSharing from 'components/SocialSharing';

const RichTextBlockQuote = ({ fields, ...otherProps }) => {
  const { quote, speaker } = flattenRichText(fields) || {};
  const { firstName, lastName, photo, jobTitle } = speaker || {};

  const formattedQuote = quote?.startsWith('“') ? quote.substring(1) : quote;

  return (
    <BlockQuoteContainer {...otherProps}>
      <div className="blog-block-quote--content">
        <p className="blog-block-quote--quote">{formattedQuote}</p>
        <div className="blog-block-quote--author-sharing">
          {speaker && (
            <div className="blog-block-quote--author">
              {photo?.image && (
                <div className="blog-block-quote--photo">
                  <WebsiteImage alt={`${firstName} ${lastName}`} image={photo.image} />
                </div>
              )}
              {(firstName || jobTitle) && (
                <div className="blog-block-quote--author-info">
                  {firstName && (
                    <p className="blog-block-quote--speaker-name">{`${firstName} ${lastName}`}</p>
                  )}
                  {jobTitle && <p className="blog-block-quote--speaker-title">{`${jobTitle}`}</p>}
                </div>
              )}
            </div>
          )}
          <SocialSharing placement="quote" shareText={quote} />
        </div>
      </div>
    </BlockQuoteContainer>
  );
};

export default RichTextBlockQuote;
